<template>
  <div class="popup-block"
       :class="popup_block_class_list">
    <template>
      <transition name="fade_popup">
        <div
          v-show="shown_transition"
          class="popup-block_shadow"
          @click="closeModal">
        </div>
      </transition>
      <transition name="slide_popup">
        <div
          v-show="shown_transition"
          class="popup-block_el"
          :class="class_list">
          <div class="popup-block_el-content">
            <div class="popup-block_el-content-header">
              <div class="popup-block_el-content-header-title">
                <slot name="popup_title"/>
              </div>
              <div
                @click="closeModal"
                class="popup-block_el-content-header-close">
                <svg xmlns="http://www.w3.org/2000/svg"
                     height="20"
                     viewBox="0 0 512 512"
                     width="20">
                    <path
                      d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"/>
                </svg>
              </div>
            </div>
            <div class="popup-block_el-content-header-sub_title">
              <slot name="popup_sub_title"/>
            </div>
            <div v-if="head_status_text" class="px-2">
              <div class="alert"
                   :class="header_status_error ? 'alert-danger' : 'alert-success'"
                   role="alert">
                {{ head_status_text }}
              </div>
            </div>
            <div class="popup-block_el-content-body">
              <div v-if="green_header" class="popup-block_el-content-body_checkmark">
                <svg width="40" height="30" viewBox="0 0 40 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M36.334 4.16666L14.6673 25.8333L3.83398 15" stroke-width="7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div v-if="green_header_info" class="popup-block_el-content-body_checkmark">
                <svg width="10" height="36" viewBox="0 0 10 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.064 0.383998L8.056 23.856H1.096L0.0880003 0.383998H9.064ZM8.872 27.792V36H0.328V27.792H8.872Z" fill="#3A913F"/>
                </svg>
              </div>
              <slot/>
            </div>
            <div
              v-show="has_popup_footer"
              class="popup-block_el-content-footer">
              <slot name="popup_footer"/>
            </div>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import {ssr_document} from "../../helpers/ssr";

export default {
  name: 'PopupBlock',
  props: {
    shown: {
      type: Boolean,
      default: false,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    is_wide: {
      type: Boolean,
      default: false,
    },
    is_wider: {
      type: Boolean,
      default: false,
    },
    loader: {
      type: Boolean,
      default: false
    },
    head_status_text: {
      type: String,
      default: ''
    },
    header_status_error: {
      type: Boolean,
      default: false
    },
    green_header: {
      type: Boolean,
      default: false
    },
    green_header_info: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      local_shown: false,
      shown_transition: false,
      timeout_f: false
    }
  },
  computed: {
    has_popup_footer() {
      return !!this.$slots.popup_footer
    },
    popup_block_class_list() {
      return {
        opened: this.shown,
      }
    },
    class_list() {
      return {
        wide: this.is_wide,
        wider: this.is_wider,
        green_header: this.green_header || this.green_header_info,
      }
    }
  },
  methods: {
    closeSiblingsModals() {
      let el = ssr_document.querySelector('.popup-block.opened')
      if (el?.__vue__?.shown) {
        el.__vue__.closeModal()
      }
    },
  },
  watch: {
    shown(newVal) {
      if (newVal) {
        clearTimeout(this.timeout_f)
        this.closeSiblingsModals()
        this.local_shown = true

      } else {
        this.timeout_f = setTimeout(() => {
          this.local_shown = false
        }, 300)
      }
      this.$nextTick(() => {
        this.shown_transition = newVal
      })
      ssr_document.body.style.overflow = newVal ? 'hidden' : 'unset'
    }
  }
}
</script>
